module.exports = __webpack_public_path__ + "static/media/entregarinju.a55d8cff.mp3";